import type { FC } from 'react';

export interface AdaptedService {
  name: string;
  cost: number;
  discount: number;
  costWithDiscount: number;
}
export interface AdaptedRecord {
  id: number;
  date: string;
  time: string;
  performer: string;
  statusColor: string;
  statusText: string;
  services: AdaptedService[];
  paid: number;
  // Комментарий к записи; пустая строка — комментария нет, блок не рисуется.
  comment: string;
}
export interface AdaptedDay {
  date: string;
  records: AdaptedRecord[];
}
export interface VisitsTableProps {
  data: AdaptedDay[];
  onOpenRecord: (recordId: number) => void;
  onOpenRecordNewTab: (recordId: number) => void;
}

export interface VisitsHistoryProps {
  clientId: number | null;
}

export type VisitsTableType = FC<VisitsTableProps>;
export type VisitsHistoryType = FC<VisitsHistoryProps>;

type SelectType = 'all-visits' | 'visits-without-payment';

export type FilterItemType = {
  key: number;
  title: string;
  value: SelectType;
  testId: string;
};

export enum StatusColor {
  visited = '#4caf50',
  confirmed = '#F0AD4E',
  waiting = '#ADD8E6',
  canceled = '#f44336',
  novisit = '#e14f4f',
}

export enum StatusText {
  visited = 'Клиент пришел',
  confirmed = 'Клиент подтвержден',
  waiting = 'Ожидание клиента',
  canceled = 'Отменен',
  novisit = 'Клиент не пришел',
}

export interface UseVisitsHistoryEffectsProps {
  getClientRecordsHandler(): void;
}
